import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { InputTextComponent } from '../input-text/input-text.component';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from '@app/_services/alert.service';
import { SvgComponent } from '../../svg/svg.component';
import { notOnlyWhitespace } from '@app/_directives/form-validator.directive';
import { SettingsService } from '@app/_services/settings.service';

@Component({
    selector: 'app-input-goal',
    imports: [
        CommonModule,
        SvgComponent,
        InputTextComponent
    ],
    templateUrl: './input-goal.component.html',
    styleUrl: './input-goal.component.scss'
})

export class InputGoalComponent {

  control: FormControl = new FormControl('', [Validators.required, Validators.maxLength(80), notOnlyWhitespace()]);

  constructor(public dialogRef: MatDialogRef<InputGoalComponent>, @Inject(MAT_DIALOG_DATA) public data: { value: string }, private alertService: AlertService,
    private dialog: MatDialog,
    public ss: SettingsService
  ) {
    this.control.setValue(data.value);

    dialogRef.backdropClick().subscribe(async () => {
      this.closeDialog();
    });
  }

  hasChanges(): boolean {
    return this.control.value !== this.data.value;
  }

  save() {
    this.dialogRef.close(this.control.value);
  }

  async closeDialog() {
    if (this.hasChanges()) {
      const res = await this.alertService.confirm(this.ss.t('saveChanges_title'), this.ss.t('common_discardContent'), this.ss.t('common_save'), this.ss.t('common_discard'), 'color-35', 'color-11');
      if (!res) return;
      if (res.confirm === true) {
        this.save();
      } else if (res.confirm === false) {
        this.dialogRef.close();
      }
    } else {
      this.dialogRef.close();
    }
  }

}
